// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/BrandChannel/index.css
// module id = 2376
// module chunks = 0